module.exports = __webpack_public_path__ + "img/GHS-pictogram-flamme.305cf9b5.png";